<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['12','12']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="displayOrder">Số thứ tự</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <nz-input-number nz-input formControlName="displayOrder" type="text" placeholder="Nhập số thứ tự" [jAutofocus]></nz-input-number>
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="code" nzRequired #label>Mã</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="code" type="text" placeholder="Nhập mã" [jAutofocus]>
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="name" nzRequired #label>Chính sách giáo dục</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="name" type="text" placeholder="Nhập chính sách giáo dục">
      </nz-form-control>
      </nz-form-item >
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <label nz-checkbox  formControlName="isRequiredNote" >Hỗ trợ khác</label>
        <!-- <nz-form-label nzSpan="24" nzFor="isRequiredNote">Yêu cầu nhập 'Hỗ trợ khác'</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <nz-radio-group formControlName="isRequiredNote">
            <label nz-radio [nzValue]="true">Yêu cầu</label>
            <label nz-radio [nzValue]="false">Không yêu cầu</label>
          </nz-radio-group>
      </nz-form-control> -->
      </nz-form-item >
    </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>